import { createApp } from 'vue';
import App from './App.vue';
import './assets/styles.css'; // Import global styles
createApp(App).mount('#app');
